export const blockIconsMapsZoomOutMapNew = (
	<span className='material-symbols-outlined'>zoom_out_map</span>
);
